import React, {useEffect} from 'react';
import { useQuery } from "@apollo/client";
import { GET_PRIVACY } from "queries/queries";

const DataProtection = () => {
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  const privacyTerms = useQuery(GET_PRIVACY, {
    fetchPolicy: "no-cache",
  });

  return (
    <>
      <div className="scrollable">
        <div className="profile-dataprotection">
          <div className="profile-text-container">
            <div dangerouslySetInnerHTML={{ __html: privacyTerms.data?.getPrivacy?.content }}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DataProtection;
